import RedirectPath from '@/RedirectPath.js'

export default {

  config: {
    targetPage: '/short-terms',
    // #2980 Add here links, that should be allowed for user's that haven't accepted terms.
    allowedPages: ['/short-terms', '/terms', '/users/login', '/logout', '/tokenized', '/admin/auth-token', '/urlexpired', '/mailedurlexpired', '/pdfv2'],
    key: 'has_accepted_terms',
    loginPage: '/users/login'
  },

  /**
   * #2980 Redirect new authorized users to the terms page.
   * @param {object} response
   * @return {boolean}
   */
  redirectToTerms(response, keepStatusInStorage = true) {

    // Ignore unauthorized or authorized that has accepted the terms.
    if (!this.mustAcceptTerms(response)) {

      if (keepStatusInStorage) {
        localStorage.setItem(this.config.key, true);
      }

      return false;
    }

    if (keepStatusInStorage) {
      localStorage.setItem(this.config.key, false);
    }

    if(!this.isInAllowedPages(window.location.pathname, this.config.allowedPages) && this.isAuthorized(response)) {
        window.location.href = `${this.config.targetPage}${RedirectPath.getAsQueryString()}`;
    } else if(!this.isInAllowedPages(window.location.pathname, this.config.allowedPages) && !this.isAuthorized(response)) {
      window.location.href = this.config.loginPage + '?error=general_errors.something_went_wrong';
    }

    return true;
  },

  /**
   * #2980 Return true if the authorized user have accepted the terms.
   * @param {object} response
   * @returns {boolen}
   */
  mustAcceptTerms(response) {
    return this.isAuthorized(response) && !this.hasAcceptedTerms(response);
  },

  /**
   * #2980 Has user accepted the terms.
   * @param {object} response
   * @returns {boolen}
   */
  hasAcceptedTerms(response) {
    return typeof response.data[this.config.key] !== 'undefined' && (response.data[this.config.key] == true || parseInt(response.data['user_id']) === parseInt(localStorage.getItem('became')) );
  },

  /**
   * #2980 Check if the page is in the allowed page list.
   * @param {string} page
   * @param {Array} allowedPages
   * @return {boolean}
   */
  isInAllowedPages(page, allowedPages) {
    let alowedPageCnt = this.config.allowedPages.length;
    let isInAllowedPages = false;

    for (let i = 0; i < alowedPageCnt; i++) {
      if (page.indexOf(this.config.allowedPages[i]) == 0) {
        isInAllowedPages = true;
        break;
      }
    }

    return isInAllowedPages;
  },

  /**
   * #2980 Require new users to accept terms.
   * @param {object} response
   * @return {boolean}
   *
   * Example:
   * response: {status: 200, data.token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJ..."}
   * > true
   *
   * response: {status: 400, data.token: ""}
   * > false
   */
  isAuthorized(response) {

    const authorized = response.status == 200 && typeof response.data.token !== 'undefined' && response.data.token !== null;

    if(!authorized) {
      localStorage.removeItem('became')
    }

    return authorized;
  }

}
